module.exports = __webpack_public_path__ + "img/TipperRoof_Overview-Front_1.cec8f47e.jpg";